import api from './api';

export type SkillType = 'Listening' | 'Speaking' | 'Reading' | 'Writing';

export interface PracticeTest {
  id: string;
  user_id: string;
  test_name: string;
  test_type?: string;
  skill_tested: SkillType;
  scheduled_date: string;
  completed: boolean;
  score?: number;
  max_score?: number;
  duration_minutes?: number;
  notes?: string;
  created_at: string;
  updated_at?: string;
}

export interface PracticeTestCreate {
  test_name: string;
  test_type?: string;
  skill_tested: SkillType;
  scheduled_date: string;
  duration_minutes?: number;
}

export interface PracticeTestUpdate {
  test_name?: string;
  test_type?: string;
  skill_tested?: SkillType;
  scheduled_date?: string;
  completed?: boolean;
  score?: number;
  max_score?: number;
  duration_minutes?: number;
  notes?: string;
}

class PracticeTestsService {
  async getAll(): Promise<PracticeTest[]> {
    const response = await api.get('/practice-tests/');
    return response.data;
  }

  async getById(id: string): Promise<PracticeTest> {
    const response = await api.get(`/practice-tests/${id}`);
    return response.data;
  }

  async create(test: PracticeTestCreate): Promise<PracticeTest> {
    const response = await api.post('/practice-tests/', test);
    return response.data;
  }

  async update(id: string, test: PracticeTestUpdate): Promise<PracticeTest> {
    const response = await api.patch(`/practice-tests/${id}`, test);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/practice-tests/${id}`);
  }
}

export const practiceTestsService = new PracticeTestsService();

